var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Langs.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"Langs\">\n    ";
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"LANGUAGE_CODE");
frame.set("LANG", t_1, true);
if(frame.topLevel) {
context.setVariable("LANG", t_1);
}
if(frame.topLevel) {
context.addExport("LANG", t_1);
}
output += "\n\n    <a ";
if(runtime.contextOrFrameLookup(context, frame, "LANG") == "en") {
output += "href=\"";
output += runtime.suppressValue((lineno = 3, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "other_lang"), "other_lang", context, [runtime.contextOrFrameLookup(context, frame, "request"),"offcon"])), env.opts.autoescape);
;
}
output += "\"\n       class=\"Langs-link ";
if(runtime.contextOrFrameLookup(context, frame, "LANG") == "ru") {
output += "isActive";
;
}
output += "\">ru</a>\n\n    <a ";
if(runtime.contextOrFrameLookup(context, frame, "LANG") == "ru") {
output += "href=\"";
output += runtime.suppressValue((lineno = 6, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "other_lang"), "other_lang", context, [runtime.contextOrFrameLookup(context, frame, "request"),"offcon"])), env.opts.autoescape);
;
}
output += "\"\n       class=\"Langs-link ";
if(runtime.contextOrFrameLookup(context, frame, "LANG") == "en") {
output += "isActive";
;
}
output += "\">en</a>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Langs.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Langs/Langs.jinja
// module id = 121
// module chunks = 0